import { render, staticRenderFns } from "./DcmDashboard.vue?vue&type=template&id=0fdc221a&scoped=true"
import script from "./DcmDashboard.vue?vue&type=script&lang=js"
export * from "./DcmDashboard.vue?vue&type=script&lang=js"
import style0 from "./DcmDashboard.vue?vue&type=style&index=0&id=0fdc221a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdc221a",
  null
  
)

export default component.exports